import {ReactNode} from 'react';
import MapContainer from './MapContainer';
import {CountyFillPaintFactory} from './boundary-layer-strategies';
import {IAdequacyByCountyTableRow} from '../types';

interface ISpecialtyMapsProps {
    firstMapKey: string;
    secondMapKey: string;
    renderFirstImage: boolean;
    renderSecondImage: boolean;
    imgWidth: number | string;
    imgHeight: number | string;
    onRenderDone: () => void;
    specialtyCode?: string; // Filter map to show only this specialty's providers
    countyData?: IAdequacyByCountyTableRow[] | null; // Per-specialty adequacy data for fill strategies
    firstMapFillFactory?: CountyFillPaintFactory; // Fill strategy for first map (e.g. population gradient)
    secondMapFillFactory?: CountyFillPaintFactory; // Fill strategy for second map (e.g. pass/fail)
    firstMapLegend?: ReactNode; // Legend overlay for first map
    secondMapLegend?: ReactNode; // Legend overlay for second map
}

const SpecialtyMaps = (props: ISpecialtyMapsProps) => {
    return (
        <>
            {/* First map: Provider/Facility locations with pins filtered by specialty */}
            <MapContainer
                key={props.firstMapKey}
                id={props.firstMapKey}
                renderMap={props.renderFirstImage}
                onRenderDone={props.onRenderDone}
                title={'MEMBER / FACILITY LOCATIONS'}
                subtitle="Note: Yellow pins denote provider/facility locations"
                mapStyle={{
                    width: props.imgWidth,
                    height: props.imgHeight
                }}
                specialtyCode={props.specialtyCode}
                countyFillPaintFactory={props.firstMapFillFactory}
                countyData={props.countyData}
                legend={props.firstMapLegend}
            />
            {/* Second map: County boundaries with pass/fail or custom fill */}
            {/* No specialtyCode passed = no provider pins, ready for county boundary layers */}
            <MapContainer
                key={props.secondMapKey}
                id={props.secondMapKey}
                renderMap={props.renderSecondImage}
                onRenderDone={props.onRenderDone}
                title={'NETWORK ADEQUACY - PASS / FAIL'}
                mapStyle={{
                    width: props.imgWidth,
                    height: props.imgHeight
                }}
                countyFillPaintFactory={props.secondMapFillFactory}
                countyData={props.countyData}
                legend={props.secondMapLegend}
            />
        </>
    );
};

export default SpecialtyMaps;
